import { Category, Notification, Partner, Product, PurchaseOrder, Register, RegisterClient, Reject, Service, SystemSetting, Track } from "@/types";
import { apiRequest } from "./api-gateway";
import { TrackResponse } from "@/types";

async function login(email: string, password: string) {
    return apiRequest("POST", "/Accounts/Login", {
        data: { email, password },
        showLoading: false,
    });
}

async function forget(forget: any) {
    return apiRequest("POST", "/Accounts/Forget", {
        data: forget,
        showLoading: false,
    });
}

async function resetPassword(resetPassword: any) {
    return apiRequest("POST", "/Accounts/ResetPassword", {
        data: resetPassword,
        showLoading: false,
    });
}

async function fetchRoles() {
    return apiRequest("GET", "/Roles", {
        showLoading: false,
    });
}

async function fetchRoleById(id: string) {
    return apiRequest("GET", `/Roles/${id}`, {
        showLoading: false,
    });
}

async function deleteRole(id: string) {
    return apiRequest("DELETE", `/Roles/${id}`, {
        showLoading: false,
    });
}

async function fetchUsers() {
    return apiRequest("GET", "/Users", {
        showLoading: false,
    });
}

async function createRole(roleName: string, permission?: string) {
    return apiRequest("POST", "/Roles", {
        data: {
            id: null,
            name: roleName,
            normalizedName: roleName.toLowerCase(),
            permission,
        },
        showLoading: false,
    });
}

async function updateRole(id: string, roleName: string, permission?: string) {
    return apiRequest("PUT", "/Roles/" + id, {
        data: {
            id: id,
            name: roleName,
            normalizedName: roleName.toUpperCase(),
            permission,
        },
        showLoading: false,
    });
}

async function createUser(register: Register) {
    return apiRequest("POST", "/Accounts/Register", {
        data: {
            fullName: register.fullName,
            mobile: register.mobile,
            title: register.title,
            email: register.email,
            countryISOTwo: register.countryISOTwo,
            password: register.password,
            type: "Staff",
        },
        showLoading: false,
    });
}

async function assignRole(userId: string, roleId: string) {
    console.log("Assigning role:", userId, roleId);
    return apiRequest("POST", `/Users/${userId}/assign-role/${roleId}`, {
        showLoading: false,
    });
}

async function removeRole(userId: string, roleId: string) {
    return apiRequest("DELETE", `/Users/${userId}/remove-role/${roleId}`, {
        showLoading: false,
    });
}

async function fetchUsersByRole(roleId: string) {
    return apiRequest("GET", `/Users/GetUsersByRole/${roleId}`, {
        showLoading: false,
    });
}

async function fetchOrders() {
    return apiRequest("GET", "/Orders", {
        showLoading: false,
    });
}

async function fetchOrderByTrackingNumber(trackingNumber: string) {
    return apiRequest("GET", `/Orders/search/${trackingNumber}`, {
        showLoading: false,
    });
}

async function createOrder(orderData: any) {
    return apiRequest("POST", "/Orders", {
        data: orderData,
        showLoading: false,
    });
}

async function updateOrder(id: string, orderData: any) {
    return apiRequest("PUT", "/Orders/" + id, {
        data: orderData,
        showLoading: false,
    });
}

async function fetchOrderById(id: string) {
    return apiRequest("GET", `/Orders/GetOrderById/${id}`, {
        showLoading: false,
    });
}

async function fetchTracks(orderId: string) {
    return apiRequest("GET", `/Orders/${orderId}/tracks`, {
        showLoading: false,
    });
}

async function fetchShipment(orderId: string) {
    return apiRequest("GET", `/Orders/${orderId}/shipment`, {
        showLoading: false,
    });
}

// updateOrderStatus
async function updateOrderStatus(id: string, orderStatus: string) {
    return apiRequest("PUT", `/Orders/${id}/${orderStatus}`, {
        showLoading: false,
    });
}

async function rejectOrder(rejectOrder :Reject) {
    return apiRequest("POST", `/Orders/reject`, {
        data: rejectOrder,
        showLoading: false,
    });
}

// create order track
async function createOrderTrack(orderId: string, track: Track) {
    return apiRequest("POST", `/Orders/${orderId}/tracks`, {
        data: track,
        showLoading: false,
    });
}

async function addShipment(orderId: string, shipment: any) {
    return apiRequest("POST", `/Orders/${orderId}/shipment`, {
        data: shipment,
        showLoading: false,
    });
}

// fetch Billings
async function fetchBillings(orderId: string) {
    return apiRequest("GET", `/Transactions/GetTransactionByOrder/${orderId}`, {
        showLoading: false,
    });
}

async function fetchBillingsByCustomer(customerId: string) {
    return apiRequest("GET", `/Transactions/GetTransactionByCustomer/${customerId}`, {
        showLoading: false,
    });
}

async function createBilling(orderId: string, Billing: any, type: string) {
    return apiRequest("POST", `/Transactions/AddTransaction/${type}/${orderId}`, {
        data: Billing,
        showLoading: false,
    });
}

async function deleteBilling(billingId: string) {
    return apiRequest("DELETE", `/Transactions/${billingId}`, {
        showLoading: false,
    });

}

async function fetchCategories() {
    return apiRequest("GET", "/Categories", {
        showLoading: false,
    });
}

async function addCategory(category: Category) {
    return apiRequest("POST", "/Categories", {
        data: category,
        showLoading: false,
    });
}

async function addPurchaseOrder(orderId: string, purchaseOrder: PurchaseOrder) {
    return apiRequest("POST", `/Orders/${orderId}/purchase-order`, {
        data: purchaseOrder,
        showLoading: false,
    });
}

// await fetchProducts();
async function fetchProducts() {
    return apiRequest("GET", "/Products", {
        showLoading: false,
    });
}

async function addProduct(product: Product) {
    return apiRequest("POST", "/Products", {
        data: product,
        showLoading: false,
    });
}

async function fetchClients() {
    return apiRequest("GET", "/Clients", {
        showLoading: false,
    });
}
// [HttpGet("GetClientById/{id}")]
async function fetchClientById(id: string) {
    return apiRequest("GET", `/Clients/GetClientById/${id}`, {
        showLoading: false,
    });
}

async function CreateClient(register: Register) {
    return apiRequest("POST", "/Accounts/Register", {
        data: register,
        showLoading: false,
    });
}

// RemoveClient
async function RemoveClient(clientId: string) {
    return apiRequest("DELETE", `/Clients/${clientId}`, {
        showLoading: false,
    });
}

async function fetchCustomerOrders(customerId: string) {
    return await  apiRequest("GET", `/Orders/customer/${customerId}`, {
        showLoading: false,
    });
}

// fetch systemSetting
async function fetchSystemSetting() {
    return await apiRequest("GET", "/SystemSettings", {
        showLoading: false,
    });
}

async function fetchSystemSettingById(id: string) {
    return await  apiRequest("GET", `/SystemSettings/${id}`, {
        showLoading: false,
    });
}

// create systemSetting
async function createSystemSetting(data: SystemSetting) {
    return apiRequest("POST", "/SystemSettings", {
        data,
        showLoading: false,
    });
}

// update systemSetting

async function updateSystemSetting(id: string, data: SystemSetting) {
    return apiRequest("PUT", `/SystemSettings/${id}`, {
        data,
        showLoading: false,
    });
}

// fetchPartners
async function fetchPartners() {
    return apiRequest("GET", "/Partners", {
        showLoading: false,
    });
}

// fetchPartnerById
async function fetchPartnerById(id: string) {
    return apiRequest("GET", `/Partners/${id}`, {
        showLoading: false,
    });
}

// createPartner
async function createPartner(data: Partner) {
    return apiRequest("POST", "/Partners", {
        data,
        showLoading: false,
    });
}

// updatePartner
async function updatePartner(id: string, data: Partner) {
    return apiRequest("PUT", `/Partners/${id}`, {
        data,
        showLoading: false,
    });
}

// fetchServices
async function fetchServices() {
    return apiRequest("GET", "/Services", {
        showLoading: false,
    });
}

// fetchServiceById
async function fetchServiceById(id: string) {
    return apiRequest("GET", `/Services/${id}`, {
        showLoading: false,
    });
}

// createService
async function createService(data: Service) {
    return apiRequest("POST", "/Services", {
        data,
        showLoading: false,
    });
}

// updateService
async function updateService(id: string, data: Service) {
    return apiRequest("PUT", `/Services/${id}`, {
        data,
        showLoading: false,
    });
}

// fetch notification
async function fetchNotification() {
    return apiRequest("GET", "/Notifications", {
        showLoading: false,
    });
}

// fetch notification by id
async function fetchNotificationById(id: string) {
    return apiRequest("GET", `/Notifications/${id}`, {
        showLoading: false,
    });
}

// create notification
async function createNotification(data: Notification) {
    return apiRequest("POST", "/Notifications", {
        data,
        showLoading: false,
    });
}

// update notification
async function updateNotification(id: string, data: Notification) {
    return apiRequest("PUT", `/Notifications/${id}`, {
        data,
        showLoading: false,
    });
}

export {
    login,
    fetchRoles,
    fetchRoleById,
    fetchUsers,
    createRole,
    updateRole,
    deleteRole,
    createUser,
    assignRole,
    removeRole,
    fetchUsersByRole,
    fetchOrders,
    createOrder,
    updateOrder,
    fetchOrderById,
    fetchTracks,
    fetchShipment,
    updateOrderStatus,
    rejectOrder, 
    createOrderTrack,
    addShipment,
    fetchBillings,
    fetchBillingsByCustomer,
    createBilling,
    deleteBilling,
    fetchCategories,
    addCategory,
    addPurchaseOrder,
    fetchOrderByTrackingNumber,
    fetchProducts,
    addProduct,
    fetchClients,
    fetchClientById,
    CreateClient,
    RemoveClient,
    fetchCustomerOrders,
    fetchSystemSetting,
    createSystemSetting,
    updateSystemSetting,
    fetchPartners,
    createPartner,
    updatePartner,
    fetchServices,
    createService,
    updateService,
    fetchNotification,
    createNotification,
    updateNotification,
    fetchNotificationById,
    fetchPartnerById,
    fetchServiceById,
    forget,
    resetPassword,
};